import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import StepperComponent from "./components/Stepper/StepperComponent";

const OrderStatusStepper = ({
  activeStepIndex,
}: {
  activeStepIndex: number;
}) => {
  const { t } = useTranslation("orders");
  const getSteps = [
    {
      label: t("orders:order.statusStepper.orderEntry"),
      index: 0,
    },
    {
      label: t("orders:order.statusStepper.orderReview"),
      index: 1,
    },
    {
      label: t("orders:order.statusStepper.orderSubmit"),
      index: 2,
    },
  ];
  const theme = useTheme();

  return (
    <Box
      data-testid="order-status-stepper"
      sx={{
        border: "1px solid",
        borderColor: theme.tokens.FuelColorBorderLight,
        borderRadius: theme.tokens.FuelBorderRadiusLg,
        p: theme.tokens.FuelSpacing3,
        paddingBottom: 0,
      }}
    >
      <StepperComponent steps={getSteps} activeStepIndex={activeStepIndex} />
    </Box>
  );
};

export default OrderStatusStepper;
